import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material/dialog';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { SocketService } from 'src/app/services/socket/socket.service';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { environment } from 'src/environments/environment';
import { CreateGraphComponent } from '../create-graph/create-graph.component';

@Component({
  selector: 'app-subject-map',
  templateUrl: './subject-map.component.html',
  styleUrls: ['./subject-map.component.scss']
})
export class SubjectMapComponent implements OnInit{

  createProjectMode = 102;
  projetNameOne: string = ''
  tagNameOne: string = '';
  addingTagMember = [];
  addingTagEmails = [];
  //tagListadded = [];
  tagMemberAffected = [];
  tagUserSelected = [];
  addingMember = [];
  hasMemberAdding = false;
  currentUser = null;
  subjects: any[] = [];
  projectUsers: any[] = [];
  allProjectUsers: any[] = [];
  project: any;
  idProjet = null;
  SubNum = 0;
  btntagclicked = false;
  searchTagContact: any;
  userStatus = [];
  isAdmin = false;
  hideHeader = false;
  contacts = [];
  emailPattern: string = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  @ViewChild('createGraphComponent', {static: false}) createGraphComponent: CreateGraphComponent;
  //@Input() subjects: any[] = [];
  //@Input() projectUsers: any[] = [];
  //@Input() project: any;
  vibrantColors = [
    "#FF5733", // Rouge vif
    "#FF8D1A", // Orange vif
    "#F9C74F", // Jaune doré
    "#4CAF50", // Vert
    "#D32F2F", // Rouge profond
    "#9C27B0", // Violet
    "#E91E63", // Rose
    "#FFEB3B", // Jaune
    "#00BCD4", // Bleu clair
    "#FF5722", // Orange foncé
    "#3F51B5", // Bleu indigo
    "#9E9D24", // Jaune-vert
    "#FF7043", // Orange corail
    "#8E24AA", // Violet intense
    "#388E3C"  // Vert forêt
  ];
  mailInputShow = 0;
  contactemail = '';
  inputemail = '';

  constructor(
    public dialogRef: MatDialogRef<SubjectMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private socketService: SocketService,
    private router: Router,
    private route: ActivatedRoute,
    public  dialog: MatDialog)   {
      this.project = data.project;
      this.allProjectUsers = data.projectUsers;
      this.projectUsers = data.projectUsers.map(item => item.user);
      this.subjects = data.subjects;
      this.idProjet = data.idProjet;
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.SubNum = this.subjects.length;
      this.projetNameOne = this.project.libelle;
      this.isAdmin = data.isAdmin;
    }

    hideHeaderInterface(){
      this.hideHeader = !this.hideHeader;
    }

    onProjectRenamed(newName: string) {
      this.projetNameOne = newName;
    }

    ngOnInit(): void {
      this.loadContact();
      /*this.authService.getMyContacts(this.currentUser['compId']).subscribe(res => {
        this.contacts = this.contacts.concat(res['hydra:member']);
        this.contacts = this.contacts.sort(function (a, b) {
          if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) { return -1; }
          if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) { return 1; }
          return 0;
        })
      })*/
    }

    openInvitations(){
      this.mailInputShow = 1;
      this.inputemail = '';
      this.contactemail = '';
    }
    
    addInputExternalEmail() {
      if (!this.inputemail) return;
      const email = this.inputemail.trim().toLowerCase();
      console.log('emaaail : '+email)
      if (email && !this.addingTagEmails.includes(email)) {
      console.log('emaaail add : '+email)
        this.addingTagEmails.push(email);
      }
      this.inputemail = '';
    }
    
    addExternalEmail(emailsent = null) {
      if (!this.inputemail && !emailsent) return;
      var email = emailsent;
      if(!emailsent) email = this.inputemail.trim().toLowerCase();
      if (email && !this.addingTagEmails.includes(email)) {
        this.addingTagEmails.push(email);
      }
      this.inputemail = '';
    }

    isEmailValid(email: string): boolean {
        const regex = new RegExp(this.emailPattern);
        return regex.test(email);
    }

    hideMailInput(){
      this.mailInputShow = 0;
      this.inputemail = '';
      this.contactemail = '';
    }

    loadContact() {
      //this.authService.getMyContacts(this.currentUser['compId']).subscribe(res => {
      this.authService.getCompagnyMember(this.currentUser['compId']).subscribe(res => {
        this.contacts = res['hydra:member'];
        this.contacts = this.contacts.filter(contact => !contact.user || contact.user.id !== this.currentUser.id).sort(function (a, b) {
          if (a.user.fullName.toLowerCase() < b.user.fullName.toLowerCase()) { return -1; }
          if (a.user.fullName.toLowerCase() > b.user.fullName.toLowerCase()) { return 1; }
          return 0;
      })
        this.contacts.forEach(contact => {
          contact.user.color = this.getRandomColor();
        });
      },
        err => {
          const error = err.error;
          const errorS = error.message;
          const errorD = error.detail;
          const errorH = error['hydra:description'];
          if (errorS === 'Bad credentials') {
            alert(errorS);
          } else if (errorD === "L'utilisateur n'est pas encore activé. pour l'activer, vous devez cliquer sur le lien de confirmation du mail que vous avez reçu") {
            alert(errorD);
          } else if (errorH) {
            alert(errorH);
          }
        });
    }

    getRandomColor(): string {
      const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
      return this.vibrantColors[randomIndex];
    }

    selectAllUsers(){
      this.addingTagMember = [];
      this.projectUsers.forEach((item) => this.addingTagMember.push(item));
    }
    deselectAllUsers(){
      this.addingTagMember = [];
    }

    onNoClick(): void {
      if (this.createProjectMode === 101) {
      this.createProjectMode = 102;
    } else if (this.createProjectMode === 102 && !this.hideHeader) {
        this.dialogRef.close();
    } else if (this.createProjectMode === 102 && this.createGraphComponent) {
      this.createGraphComponent.goBack();
      if(this.createGraphComponent.mode == 1) this.hideHeader = false;
    }
    }

    createSubject(){
      this.createProjectMode = 101;
    }
      
    getAvatarlUrl(avatarLink){
      return environment.server_url+avatarLink;
    }

    addTagToProject(){
      var general = false;
      if(this.tagNameOne.trim() == "" || this.tagNameOne.trim().length == 0){
        alert("Veuillez entrer une mission");
        return;
      } 
      /*if(this.addingTagMember.length == 0 && !this.projectDetails.isPrivate){
        alert("Veuillez sélectionner au moins un membre avant de créer la mission.");
        return;
      }*/
      this.tagUserSelected = [];
      var tagUser = [];
      tagUser.push(this.currentUser.id);
      for (var i = 0; i < this.addingTagMember.length; i++) {
        tagUser.push(this.addingTagMember[i].id);
      }
      this.addingTagMember.map(item=> {
          //tagUser.push(item.id);
          this.tagUserSelected.push(item);
          this.tagMemberAffected.push(item);
      })
      this.authService.addPersonalTagToProject({
        libelle: this.tagNameOne,
        project: this.project.id,
        isGeneral: false
      }, tagUser, this.addingTagEmails).then((res)=>{
        this.subjects.push(res);
        this.tagNameOne = "";
        this.addingTagMember = [];
        this.tagUserSelected = [];
        this.addingTagEmails = [];
        this.SubNum++;
        this.authService.obSubAdd.next(res);
        this.goBackOtherSub();
      }).catch(err=>{
        console.log(err)
      });
    }

    goBackOtherSub(){
      this.createProjectMode = 102;
    }

    
  scrollRight(container: HTMLElement) {
    container.scrollBy({ left: 100, behavior: 'smooth' });
  }

  scrollLeft(container: HTMLElement) {
    container.scrollBy({ left: -100, behavior: 'smooth' });
  }

  /*getRandomColor(): string {
    const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
    return this.vibrantColors[randomIndex];
  }*/

  getInitials(libelle: string): string {
    const words = libelle.split(' ');
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

    return initials;
  }

  getFormattedName(member: { givenName: string; familyName: string }): string {
    if(member.familyName){
      const firstInitial = member.familyName.charAt(0).toUpperCase();
      return `${member.givenName} .${firstInitial}`;
    } else return member.givenName;
    
  }

    fctCheckMemberTag(userInfo){ 
      if(this.addingTagMember && !this.addingTagMember.includes(userInfo)){
        this.fctAdMemberTag(userInfo);
      } else this.fctRemoveUserTag(userInfo);
    }

    fctAdMemberTag(userInfo){ 
      this.addingTagMember.push(userInfo);
      this.searchTagContact = "";
    }

    fctRemoveUserTag(userInfo){
      const index = this.addingTagMember.indexOf(userInfo);
      if (index > -1) {
        this.addingTagMember.splice(index, 1);
        delete this.userStatus[userInfo['id']];
        this.searchTagContact = "";
      }
    }

    fctCheckEmailTag(email){ 
      if(this.addingTagEmails && !this.addingTagEmails.includes(email)){
        this.fctRemoveEmailTag(email);
      } else this.fctRemoveUserTag(email);
    }

    fctAdEmailTag(email){ 
      this.addingTagEmails.push(email);
      this.searchTagContact = "";
    }

    fctRemoveEmailTag(email){
      const index = this.addingTagEmails.indexOf(email);
      if (index > -1) {
        this.addingTagEmails.splice(index, 1);
        //delete this.userStatus[userInfo['id']];
        this.searchTagContact = "";
      }
    }
}